import { connect } from 'react-redux';

import PdpSizeChart from 'components/PdpSizeChart';
import * as actions from 'state/actions';
import { sizeChartModalIsOpen } from 'state/selectors/pdp';
import Rudderstack from 'utils/Rudderstack';

const mapStateToProps = (state, ownProps) => {
  const {
    sizeChart,
    sizingRecommendation,
    handle,
    pdpStorytellingEnabled,
    hasSizeChartAttribute,
    handleOpenSizing,
  } = ownProps;

  const isOpen = sizeChartModalIsOpen(state, handle);

  return {
    handle,
    handleOpenSizing,
    hasSizeChartAttribute,
    isOpen,
    pdpStorytellingEnabled,
    sizeChart,
    sizingRecommendation,
  };
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(actions.closeModal()),
  onSwatchSelect: handle => dispatch(actions.openSizeChartModal(handle)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  openModal: () => {
    const { basicProductProperties } = ownProps;
    dispatchProps.onSwatchSelect(stateProps.handle);
    Rudderstack.sizeGuideOpened({
      ...basicProductProperties,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PdpSizeChart);
